/* ============================================================================
   gs-quick-pads.js — grow-some
   Path: assets/gs-quick-pads.js

   Collection quick-add for mat-selector products. On grids that render
   card-product-grow, products with data-mat-limit > 0 cannot be added with a
   bare cart/add (they need the customer to pick N seed pads = килимки first).
   This opens a small drawer with the pad picker, then adds the variant with
   the chosen pads as line-item properties — same payload as the product page
   (assets/gs-addons-bundle.js) — and opens the cart drawer. Stays on page.

   Pads-only by design: pots/packaging/spray upsells remain on the PDP.

   Depends on: assets/gs-mats-data.js (window.GS_MATS, window.GS_decKyl),
               assets/gs-addons-bundle.css (.gs-mat-grid/.gs-mat-card styles).
   ============================================================================ */
(function () {
  if (window.__gsQuickPadsBound) return;
  window.__gsQuickPadsBound = true;

  var MATS = window.GS_MATS || [];
  var decKyl = window.GS_decKyl || function (n) {
    var a = Math.abs(n) % 100, r = a % 10;
    if (a >= 11 && a <= 19) return 'килимків';
    if (r === 1) return 'килимок';
    if (r >= 2 && r <= 4) return 'килимки';
    return 'килимків';
  };

  var MINUS_SVG = '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="0" y="6" width="14" height="2" fill="currentColor"/></svg>';
  var PLUS_SVG  = '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="0" y="6" width="14" height="2" fill="currentColor"/><rect x="6" y="0" width="2" height="14" fill="currentColor"/></svg>';

  // ── Per-open state ──────────────────────────────────────────────────
  var variantId = 0;
  var limit = 0;
  var qtys = {};
  var lastTrigger = null;
  var busy = false;
  var closeTimer = null;

  var els = null; // built lazily

  function total() {
    return MATS.reduce(function (s, m) { return s + (qtys[m.id] || 0); }, 0);
  }

  // ── Build the drawer shell once ─────────────────────────────────────
  function build() {
    if (els) return els;

    var overlay = document.createElement('div');
    overlay.className = 'gsqp-overlay';
    overlay.setAttribute('hidden', '');

    overlay.innerHTML =
      '<div class="gsqp-panel" role="dialog" aria-modal="true" aria-labelledby="gsqp-title" tabindex="-1">' +
        '<header class="gsqp-head">' +
          '<div class="gsqp-head-text">' +
            '<h2 class="gsqp-title" id="gsqp-title"></h2>' +
            '<p class="gsqp-sub" data-sub></p>' +
          '</div>' +
          '<button type="button" class="gsqp-close" aria-label="Закрити">' +
            '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="gsqp-body">' +
          '<div class="gs-mat-grid" data-grid></div>' +
          '<div class="gs-mat-error" data-err></div>' +
        '</div>' +
        '<footer class="gsqp-foot">' +
          '<button type="button" class="gsqp-cta" data-cta disabled></button>' +
        '</footer>' +
      '</div>';

    document.body.appendChild(overlay);

    els = {
      overlay: overlay,
      panel: overlay.querySelector('.gsqp-panel'),
      title: overlay.querySelector('.gsqp-title'),
      sub: overlay.querySelector('[data-sub]'),
      grid: overlay.querySelector('[data-grid]'),
      err: overlay.querySelector('[data-err]'),
      cta: overlay.querySelector('[data-cta]'),
      close: overlay.querySelector('.gsqp-close')
    };

    // Build the pad grid once (reuse gs-addons-bundle.css markup classes)
    els.grid.innerHTML = MATS.map(function (m) {
      return '' +
        '<div class="gs-mat-card" data-mat-id="' + m.id + '" data-mat-name="' + m.name + '">' +
          '<div class="gs-mat-img-wrap"><img src="' + m.img + '" alt="' + m.name + '" loading="lazy"></div>' +
          '<div class="gs-mat-body"><p class="gs-mat-name">' + m.name + '</p></div>' +
          '<div class="gs-mat-cnt-wrap"><div class="gs-mat-cnt">' +
            '<button class="gs-mc-btn" type="button" data-role="minus" disabled aria-label="−">' + MINUS_SVG + '</button>' +
            '<input class="gs-mc-input" type="number" value="0" min="0" data-role="input" inputmode="numeric">' +
            '<button class="gs-mc-btn" type="button" data-role="plus" aria-label="+">' + PLUS_SVG + '</button>' +
          '</div></div>' +
        '</div>';
    }).join('');

    els.grid.querySelectorAll('.gs-mat-card').forEach(function (card) {
      var id = card.dataset.matId;
      card.querySelector('[data-role="minus"]').addEventListener('click', function () { delta(id, -1); });
      card.querySelector('[data-role="plus"]').addEventListener('click', function () { delta(id, 1); });
      var inp = card.querySelector('[data-role="input"]');
      inp.addEventListener('focus', function () { this.select(); });
      inp.addEventListener('input', function () { typed(id, this.value, false); });
      inp.addEventListener('blur', function () { typed(id, this.value, true); });
    });

    els.cta.addEventListener('click', confirm);
    els.close.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) close();
    });

    return els;
  }

  // ── Counter logic (hard cap at limit) ───────────────────────────────
  function delta(id, d) {
    var cur = qtys[id] || 0;
    var nv = cur + d;
    if (nv < 0) return;
    if (d > 0 && total() >= limit) return;
    qtys[id] = nv;
    render();
  }
  function typed(id, val, isBlur) {
    var nv = parseInt(val, 10);
    if (isNaN(nv) || nv < 0) nv = 0;
    var others = 0;
    MATS.forEach(function (m) { if (m.id !== id) others += qtys[m.id] || 0; });
    var max = Math.max(limit - others, 0);
    if (nv > max) nv = max;
    qtys[id] = nv;
    if (isBlur) {
      var card = els.grid.querySelector('.gs-mat-card[data-mat-id="' + id + '"]');
      var inp = card && card.querySelector('[data-role="input"]');
      if (inp && parseInt(inp.value, 10) !== nv) inp.value = nv;
    }
    render();
  }

  function render() {
    var tot = total();
    var atLimit = tot >= limit;

    els.grid.querySelectorAll('.gs-mat-card').forEach(function (card) {
      var id = card.dataset.matId;
      var q = qtys[id] || 0;
      card.classList.toggle('sel', q > 0);
      card.querySelector('[data-role="minus"]').disabled = (q === 0);
      card.querySelector('[data-role="plus"]').disabled = atLimit;
      var inp = card.querySelector('[data-role="input"]');
      if (inp && document.activeElement !== inp) inp.value = q;
    });

    // Чітка інструкція вгорі (а не лише на кнопці): скільки килимків треба обрати + прогрес.
    if (tot >= limit) {
      els.sub.innerHTML = '<strong>Готово!</strong> Обрано ' + tot + ' / ' + limit;
    } else {
      els.sub.innerHTML = 'Оберіть <strong>' + limit + ' ' + decKyl(limit) + '</strong> · обрано ' + tot + ' / ' + limit;
    }

    if (busy) return;
    if (tot === 0) {
      els.cta.disabled = true;
      els.cta.textContent = 'Оберіть ' + limit + ' ' + decKyl(limit);
    } else if (tot < limit) {
      var need = limit - tot;
      els.cta.disabled = true;
      els.cta.textContent = 'Оберіть ще ' + need + ' ' + decKyl(need);
    } else {
      els.cta.disabled = false;
      els.cta.textContent = 'Додати до кошика';
    }
    if (tot === limit) els.err.classList.remove('show');
  }

  // ── Open / close ────────────────────────────────────────────────────
  function open(button) {
    build();
    variantId = parseInt(button.dataset.variantId, 10);
    limit = parseInt(button.dataset.matLimit, 10) || 0;
    if (!variantId || limit < 1 || !MATS.length) return;

    lastTrigger = button;
    qtys = {};
    MATS.forEach(function (m) { qtys[m.id] = 0; });
    busy = false;

    els.title.textContent = button.dataset.productTitle || 'Оберіть килимки';
    els.err.classList.remove('show');
    els.cta.classList.remove('gsqp-loading');
    render();

    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    els.overlay.removeAttribute('hidden');
    document.documentElement.classList.add('gsqp-open');
    requestAnimationFrame(function () {
      els.overlay.classList.add('is-open');
      els.panel.focus();
    });
  }

  function close() {
    if (!els) return;
    els.overlay.classList.remove('is-open');
    document.documentElement.classList.remove('gsqp-open');
    var ov = els.overlay;
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { ov.setAttribute('hidden', ''); closeTimer = null; }, 250);
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  // ── Add to cart (items-array + line-item properties) ────────────────
  function confirm() {
    if (busy || total() !== limit) return;
    busy = true;

    var props = {};
    MATS.forEach(function (m) {
      var q = qtys[m.id] || 0;
      if (q > 0) props['Килимок ' + m.name] = q + ' ' + decKyl(q);
    });

    els.cta.disabled = true;
    els.cta.classList.add('gsqp-loading');
    els.cta.textContent = 'Додаємо…';
    els.err.classList.remove('show');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    if (cart && typeof cart.getSectionsToRender === 'function') {
      sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: props }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (parsed) {
        // Normalize items-array response → single-line-item shape Dawn expects.
        if (parsed && parsed.items && parsed.items.length && parsed.id == null) {
          parsed.id = parsed.items[0].id;
          parsed.key = parsed.items[0].key;
        }
        document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
          var sp = b.querySelector('span:not(.visually-hidden)');
          if (sp && parsed.item_count != null) sp.textContent = parsed.item_count;
        });

        close();

        if (cart && typeof cart.renderContents === 'function') {
          if (parsed.id != null) cart.productId = parsed.id;
          try {
            cart.renderContents(parsed);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          } catch (e) {
            if (typeof cart.open === 'function') cart.open();
          }
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function (err) {
        busy = false;
        els.cta.classList.remove('gsqp-loading');
        els.err.textContent = 'Не вдалось додати: ' + (err && err.message ? err.message : 'спробуйте ще раз');
        els.err.classList.add('show');
        render();
      });
  }

  // ── Delegated trigger ───────────────────────────────────────────────
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.gp-card-cart[data-mat-limit]');
    if (!button || parseInt(button.dataset.matLimit, 10) < 1) return;
    event.preventDefault();
    event.stopPropagation();
    open(button);
  });
})();
